// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { SagaObjectManager_abstract } from './../abstract/SagaBase/SagaObjectManager_abstract';
export class SagaObjectManager extends SagaObjectManager_abstract {}
